export default __webpack_public_path__ + "static/media/Failed-Transactions-Why-&-What-to-do.0706bdbf.mp4";